<template>
	<div class="bld-features">
		<div class="container">
			<div class="row">
				<div class="col-sm-4" v-for="feature in bldFeatures" :key="feature.id">
					<div class="bld-features__feature">
						<div class="bld-features__feature__icon">
							<img
								:src="feature.mini_logo_url"
								:alt="feature.title + ' icon'"
							>
						</div>
						<div class="bld-features__feature__text">
							<h3 class="bld-features__feature__heading">
								{{ feature.title | stripTags }}
							</h3>
							<p class="bld-features__feature__description">
								{{ feature.body | stripTags }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "PrebuildBldFeatures",
	props: {
		bldFeatures: {
			type: Array,
			required: true
		}
	}
};
</script>

<style lang="scss" scoped>
.bld-features {
	background-color: #f3f3f3;
	padding: 75px 0 0;

	@media (min-width: 991px) {
		padding: 75px 0;
	}

	&__feature {
		margin-bottom: 80px;

		@media (min-width: 580px) and (max-width: 991px) {
			padding: 0 6px;
		}

		@media (min-width: 991px) {
			margin-bottom: 0;
		}

		&__icon {
			width: 65px;
			margin: 0 auto 25px;

			img {
				width: 100%;
			}
		}

		&__text {
			text-align: center;
			max-width: 295px;
			margin: 0 auto;
		}

		&__heading {
			color: #444259;
			font-size: 24px;
			font-weight: bold;
			letter-spacing: 0;
			margin: 0 0 7px;
		}

		&__description {
			color: #5f707f;
			font-size: 16px;
			letter-spacing: 0;
			line-height: 24px;
			margin: 0;
		}
	}
}
</style>
